<!-- 账户管理 -->
<template>
  <div class="mainBox" id="manage-account">
    <!-- header start -->
    <van-nav-bar
      title="账户管理"
      fixed
      :placeholder="true"
      :z-index="99"
      left-arrow
      @click-left="goBack"
    />
    <!-- header end -->
    <div class="bodyBox">
      <div class="no-bind" v-if="BankList.length <= 0">
        <img src="~@/assets/images/account.png" alt="" />
        <div class="">暂无添加提现账户</div>
      </div>
      <div class="have-bind" v-for="(item, index) in BankList" :key="index">
        <div class="alipay-box" v-if="item.AlipayAccount != null">
          <div class="alipay-box-top">
            <div class="alipay-box-top-left">
              支付宝账号<span>{{ item.AlipayAccount }}</span>
            </div>
            <div>
              <span
                class="alipay-box-top-right"
                @click.stop="goAlipay('edit', item)"
                >修改</span
              >&nbsp;&nbsp;
              <span
                class="alipay-box-top-right"
                @click.stop="del(item.SerialNumber)"
                >删除</span
              >
            </div>
          </div>
          <div class="alipay-box-bottom">
            真实姓名<span>{{ item.RealName }}</span>
          </div>
        </div>
        <div class="card-box" v-else>
          <div class="card-box-top">
            <div class="card-box-top-left">
              {{ item.CollectionBrankName }}
            </div>
            <div>
              <span
                class="card-box-top-right"
                @click.stop="goBankCard('edit', item)"
                >修改</span
              >&nbsp;&nbsp;
              <span
                class="card-box-top-right"
                @click.stop="del(item.SerialNumber)"
                >删除</span
              >
            </div>
          </div>
          <div
            class="card-box-bottom"
            v-if="
              item.CollectionNumber != null && item.CollectionNumber.length > 4
            "
          >
            {{ item.CollectionNumber.substring(0, 4) }} **** ****
            {{
              item.CollectionNumber.substring(item.CollectionNumber.length - 5)
            }}
          </div>
        </div>
      </div>
      <!-- <div class="btn-box">
        <div
          class="bind-alipay"
          v-if="BankList.length <= 0"
          @click="goAlipay('add')"
          tapmode
        >
          绑定支付宝
        </div>
        <div
          class="bind-card"
          v-if="BankList.length <= 0"
          @click="goBankCard('add')"
          tapmode
        >
          绑定银行卡
        </div>
      </div> -->
      <div class="add-button" @click="addBank()" tapmode>增加银行卡</div>
      <div class="add-button" @click="addAliPay()" tapmode>增加支付宝</div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import common from "../../../tools/common";

export default {
  data() {
    return {
      BankList: [],
    };
  },
  components: {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goAlipay(typeName, model) {
      this.$router.push({
        path: "/bindAlipay",
        query: { typeName: typeName, model: model },
      });
    },
    goBankCard(typeName, model) {
      this.$router.push({
        path: "/bindBankCard",
        query: { typeName: typeName, model: model },
      });
    },
    getBankList() {
      var _this = this;
      this.$store
        .dispatch({
          type: "GetBankList",
          ResultCount: 100,
        })
        .then((res) => {
          //console.log(res, "getBankList");
          common.Response.callNotMsgResponse(res, function(result) {
               _this.BankList = result.data;
          });
       
        });
    },
    addBank() {
      this.$router.push({
        path: "/bindBankCard",
        typeName: "add",
        query: { typeName: "add" },
      });
    },
    addAliPay() {
      this.$router.push({
        path: "/bindAlipay",
        query: { typeName: "add" },
      });
    },
    del(id) {
      var that = this;
      Dialog.confirm({
        title: "系统提示",
        message: "确认删除选中产品！",
      })
        .then(() => {
          that.$store
            .dispatch({
              type: "BankDel",
              id: id,
            })
            .then((res) => {
                common.Response.callNotMsgResponse(res, result => {
                  var _findIndex = that.BankList.findIndex(
                    x => x.SerialNumber == id
                  );
                  that.BankList.splice(_findIndex, 1);
                });
            });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
  created() {
    // var token = localStorage.getItem("token");
    // console.log(token);
    this.getBankList();
  },
};
</script>
<style scoped>
/*内容*/

.bodyBox {
  width: 100%;
  height: auto;
  padding-bottom: 1rem;
}

.no-bind {
  width: 100%;
  height: auto;
  padding-top: 1.9rem;
}

.no-bind img {
  width: 4.28rem;
  height: 4.28rem;
  display: block;
  margin: auto;
}

.no-bind div {
  font-size: 0.619rem;
  color: #999999;
  width: 100%;
  text-align: center;
  margin-top: 0.95rem;
}

.btn-box {
  width: 100%;
  height: auto;
  margin-top: 1rem;
}

.bind-alipay,
.bind-card {
  width: 76%;
  height: 2rem;
  border-radius: 180px;
  font-size: 0.8rem;
  color: #0684ff;
  border: 0.05rem solid #0684ff;
  margin: auto;
  text-align: center;
  line-height: 2rem;
  margin-top: 0.8rem;
}

.have-bind {
  width: 100%;
  height: auto;
  padding: 0rem 0.49rem;
}

.alipay-box {
  width: 100%;
  height: auto;
  background-color: #fff;
  padding: 0.8rem 0.45rem;
  border-radius: 0.3rem;
  margin-top: 0.6rem;
}

.alipay-box-top {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.alipay-box-top-left {
  font-size: 0.71rem;
  color: #666666;
  display: flex;
  align-items: center;
}

.alipay-box-top-left span {
  font-size: 0.71rem;
  color: #333;
  margin-left: 0.3rem;
}

.alipay-box-top-right {
  font-size: 0.57rem;
  color: #ff669e;
  background-color: #ffeff5;
  border-radius: 0.2rem;
  border: 0.05rem solid #ff669e;
  padding: 0rem 0.4rem;
}

.alipay-box-bottom {
  font-size: 0.71rem;
  color: #666666;
  display: flex;
  align-items: center;
  margin-top: 0.1rem;
}

.alipay-box-bottom span {
  font-size: 0.71rem;
  color: #333;
  margin-left: 1rem;
}

.card-box {
  width: 100%;
  height: 5.23rem;
  background-image: url("~@/assets/images/bank-bg.png");
  background-size: 100% 100%;
  margin-top: 0.6rem;
  border-radius: 0.3rem;
  padding: 0.7rem 0.6rem;
}

.card-box-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-box-top-left {
  font-size: 0.76rem;
  color: #ffffff;
}

.card-box-top-right {
  font-size: 0.57rem;
  color: #fff;
  border-radius: 0.2rem;
  border: 0.05rem solid #fff;
  padding: 0rem 0.4rem;
}

.card-box-bottom {
  width: 100%;
  text-align: center;
  font-size: 0.85rem;
  color: #ffffff;
  margin-top: 1.4rem;
  letter-spacing: 0.2rem;
}

.add-button {
  width: 76%;
  height: 46px;
  margin: auto;
  margin-top: 10px;
  border: 1px solid #24a378;
  font-size: 17px;
  color: #24a378;
  text-align: center;
  line-height: 46px;
  border-radius: 90px;
}
</style>
